import {
  EventProductType,
  OutgoingEventProductDto
} from 'api/dtos/events/products';
import createAdmissionProductSchema from './AdmissionProductSchema';
import createAddonProductSchema from './AddonProductSchema';
import createBundleProductSchema from './BundleProductSchema';
import BaseProductSchema from './BaseProductSchema';

/**
 * Get the appropriate validation schema based on product type
 * @param productType Type of product (admission, addon, bundle)
 * @param existingProduct Optional existing product (for edit mode)
 * @returns Yup validation schema
 */
export function getValidationSchema(
  productType: EventProductType,
  existingProduct?: OutgoingEventProductDto
) {
  const purchasedQuantity = existingProduct?.purchases || 0;

  switch (productType) {
    case 'admission':
      return createAdmissionProductSchema(purchasedQuantity);
    case 'addon':
      return createAddonProductSchema(purchasedQuantity);
    case 'bundle':
      return createBundleProductSchema();
    default:
      return createAdmissionProductSchema(purchasedQuantity);
  }
}

// Export all schemas for direct use if needed
export {
  BaseProductSchema,
  createAdmissionProductSchema,
  createAddonProductSchema,
  createBundleProductSchema
};
